// context/ThemeContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { useAuth } from './AuthContext';
import GlobalStyle from '../assets/styles/GlobalStyle';

const DEFAULT_THEME = {
  font: 'sans-serif',
  background: '#f9f9f9',
  card: '#ffffff',
  section: '#f0f0f0',
  border: '#ccc',
  borderLight: '#ddd',
  inputBorder: '#ccc',
  text: '#333',
  primary: '#007bff',
  primaryHover: '#0056b3',
  secondary: '#6c757d',
  secondaryHover: '#5a6268',
  buttonText: 'white'
};

  const ThemeContext = createContext({
    theme: DEFAULT_THEME,
    applyTheme: () => {},
  });

export const ThemeProvider = ({ children }) => {
  const { token, authChecked } = useAuth();
  const [theme, setTheme] = useState(DEFAULT_THEME);

  const applyTheme = (themeData) => {
    const {
      theme_type,
      font_family,
      background_image_url,
      background_color,
      card_background,
      section_background,
      border_color,
      input_border,
      text_color,
      primary_color,
      secondary_color,
      primary_button_color,
      primary_button_hover,
      secondary_button_color,
      secondary_button_hover,
      button_text_color,
    } = themeData;

    const liveTheme = {
      font: font_family || DEFAULT_THEME.font,
      background:
        theme_type === 'image' && background_image_url
          ? `url(${background_image_url}) center/cover no-repeat`
          : background_color || DEFAULT_THEME.background,
      card: card_background || DEFAULT_THEME.card,
      section: section_background || DEFAULT_THEME.section,
      border: border_color || DEFAULT_THEME.border,
      borderLight: DEFAULT_THEME.borderLight,
      inputBorder: input_border || DEFAULT_THEME.inputBorder,
      text: text_color || DEFAULT_THEME.text,
      primary: primary_button_color || primary_color || DEFAULT_THEME.primary,
      primaryHover: primary_button_hover || secondary_color || DEFAULT_THEME.primaryHover,
      secondary: secondary_button_color || DEFAULT_THEME.secondary,
      secondaryHover: secondary_button_hover || DEFAULT_THEME.secondaryHover,
      buttonText: button_text_color || DEFAULT_THEME.buttonText,
    };

    setTheme(liveTheme);
  };

  // Optional: load default theme after auth if no theme has been set
  useEffect(() => {
    if (authChecked && token && !theme) {
      setTheme(DEFAULT_THEME);
    }
  }, [authChecked, token]);

  return (
    <ThemeContext.Provider value={{ theme, applyTheme }}>
      <StyledThemeProvider theme={theme}>
        <GlobalStyle />
          {children}
      </StyledThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useThemeContext = () => useContext(ThemeContext);
